// extracted by mini-css-extract-plugin
module.exports = {"element":"_1TDNuY882ylvmQGkrlYVQN"};